import { useMessageReadBoundary } from "@bw/shared/hooks";
import { useMarkRead } from "./useMarkRead";

/** Player cache invalidation stays local; read-command behavior is shared. */
export function useObservedReadBoundary(
  conversationId: string,
  readMessageBatches: string[][],
  enabled = true,
  refreshStaleBatch?: (messageIds: string[]) => Promise<void>,
  revokeAuthority?: (error: unknown) => Promise<void>,
  communityId?: string,
) {
  const mutation = useMarkRead(conversationId, communityId);
  return useMessageReadBoundary(
    mutation,
    conversationId,
    readMessageBatches,
    enabled,
    refreshStaleBatch,
    revokeAuthority,
  );
}
